package com.neurobs.ccabserver.subjectsessionview.states


import com.neurobs.ccab.{Run, TestRunDetail, TestRunDisplayData}
import com.neurobs.react.{GenericState, GenericStateGenerator, StateAttribute}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.Hooks._
import slinky.core.facade.ReactElement


case class RunSelectionState (
  selectedRunState: StateAttribute[Option[Run]]
                             ) extends GenericState {

}

object RunSelectionStateGenerator extends GenericStateGenerator[RunSelectionState] {
  override def generateEmptyDefaultState(): RunSelectionState = RunSelectionState(
    emptyOptionDefaultState[Run]()
  )
}

@react
object RunSelectionStateProvider {
  case class Props(children: ReactElement*)
  val component = FunctionalComponent[Props] { props =>

    val sessionSelectionState = SessionSelectionStateGenerator.accessState
    val selectedRunState = StateAttribute(useState[Option[Run]](None))

    val runSelectionState = RunSelectionState(
      selectedRunState
    )

    useEffect(() => {
      selectedRunState.setValue(None)
    }, Vector(sessionSelectionState.selectedSessionState.value))

    RunSelectionStateGenerator.Provider(runSelectionState)(
      props.children
    )
  }
}